import React from "react";

const OutletNoticeDescription = () => (
  <div
    className="relative bg-white border rounded lt:w-2/5 clear-right float-right mb-5 lt:ml-4 border-red-500 p-2.5 border-solid box-border"
    data-testid="outlet-notice-description"
  >
    <p className="uppercase bg-white text-red-500 px-2 text-base font-semibold absolute top-0 -translate-y-1/2 left-1/2 -translate-x-1/2 whitespace-nowrap">
      This is an outlet item
    </p>
    <p className="italic text-sm-1/2 leading-4 mb-2.5 mt-2 font-semibold">
      Any warranty information listed in the manual is void unless otherwise
      stated and we will not be able to accept any returns.
    </p>
    <p className="text-sm-1/2 leading-4 font-semibold mb-1.5 uppercase">
      Return Policy
    </p>
    <p className="text-sm-1/2 leading-4 mb-2.5">
      Please note that all items are sold as is, and all sales are final. To
      ensure that each product in WebstaurantStore Outlet will work correctly
      upon arrival, it is tested by an experienced technician prior to shipping.
      We recommend that you carefully read the product description, damage/use
      description, and other related product literature such as specification
      sheets and product manuals before placing your order.
    </p>
    <p className="text-sm-1/2 leading-4 mb-2.5">
      Please inspect each item carefully when it arrives at your place of
      business. If you observe any damage not detailed in the description on
      this website that may have been caused during shipping, do not sign for
      the delivery and contact us ASAP.
    </p>
    <p className="text-sm-1/2 leading-4 font-semibold mb-1.5 uppercase">
      Cart Policy
    </p>
    <p className="text-sm-1/2 leading-4 mb-2.5">
      Because Outlet items sell quickly on a first-come, first-serve basis,
      simply placing the item in your shopping cart for checkout at a later time
      does not guarantee a &quot;hold&quot; on the item.
    </p>
    <p className="text-sm-1/2 leading-4 font-semibold mb-1.5 uppercase">
      Warranty Policy
    </p>
    <p className="text-sm-1/2 leading-4 mb-2.5">
      Note that Outlet products are sold without any warranty. If you have any
      questions or concerns about a product even after reading the description
      and product literature, please contact us.
    </p>
  </div>
);

export default OutletNoticeDescription;
